import React from "react";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../lib/site-data";

function getInitials(name) {
  return name
    .replace(/^Dr\.?\s+/i, "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0])
    .join("")
    .toUpperCase();
}

const PALETTE = [
  "bg-forest/10 text-forest",
  "bg-clay/15 text-clay",
  "bg-ink/8 text-ink",
  "bg-forest/15 text-forest",
];

function avatarTone(name) {
  return PALETTE[name.charCodeAt(0) % PALETTE.length];
}

export default function Testimonials() {
  return (
    <section
      id="stories"
      data-testid="testimonials-section"
      className="relative bg-cream py-24 lg:py-32"
    >
      <div className="container-x">
        <div className="max-w-3xl mb-12 lg:mb-16">
          <p className="text-[12.5px] font-semibold uppercase tracking-[0.18em] text-forest">
            Real members. Real moments.
          </p>
          <h2 className="mt-4 font-display text-ink text-[36px] sm:text-[44px] lg:text-[56px] font-extrabold leading-[1.05] tracking-tight text-balance">
            Helping people live their healthiest lives.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="relative overflow-hidden rounded-3xl border border-ink/10 bg-white p-6 shadow-[0_8px_32px_rgba(14,35,51,0.05)] flex flex-col"
            >
              <Quote
                className="h-7 w-7 text-clay/80"
                strokeWidth={2.2}
                aria-hidden="true"
              />
              <blockquote className="mt-4 text-[15.5px] leading-relaxed text-ink/85 flex-1">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <span
                  aria-hidden="true"
                  className={`flex h-11 w-11 items-center justify-center rounded-full font-display text-[14px] font-bold ${avatarTone(
                    t.name,
                  )}`}
                >
                  {getInitials(t.name)}
                </span>
                <div>
                  <p className="font-display text-[15px] font-bold text-ink">
                    {t.name}
                  </p>
                  <p className="text-[12.5px] text-ink/60">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
